import React from "react";
import Hero_12 from "../../components/hero/hero_12";
import CallToActions from "../../components/ico-landing/CallToActions";
import Testimonial from "../../components/testimonial/Testimonial";
import Benifits from "../../components/dao/Benifits";
import SingleBenefits from "../../components/ico-landing/SingleBenefits";
import {singleBenifits} from "../../data/benefits_data";
import { NextSeo } from 'next-seo';

const TokenTool = () => {
  const metaTitle = "Token Tool - Alchemis";
  const metaDesc = `Alchemis TokenTool platform for batch operations and managing digital assets effortlessly. Harness the power of blockchain technology with our user-friendly interface designed for beginners.`;
  const metaImg = `/images/meta/product-tokentool.png`;
  const benefitsData = [
    {
      id: 'token-1',
      title: 'Batch Send Token',
      description: 'Alchemis TokenTool\'s multi-sender functionality enables you to send tokens to multiple recipients simultaneously, saving you time and effort. With just a few clicks, you can enter the recipient addresses and specify the amount of tokens to be sent to each address. TokenTool takes care of the rest, securely executing the transactions on the blockchain. This feature is particularly useful for airdrops, distributing rewards, or conducting token sales.',
      icon: '/images/token-tool/send.svg',
      image: '/images/token-tool/send.png',
      animationImage: '/images/token-tool/tokentool-side.png',
    },
    {
      id: 'token-2',
      title: 'Batch Create Wallet',
      description: 'Managing multiple wallets can be a daunting task, but TokenTool makes it a breeze with the Batch Create Wallet feature. Whether you\'re launching an airdrop campaign or simply need to generate multiple wallets for your team members, TokenTool automates the process. With just a few clicks, you can create a batch of wallets securely and conveniently. Each wallet comes with its unique address and private key for easy access and control.',
      icon: '/images/token-tool/create.svg',
      image: '/images/token-tool/create.png',
      animationImage: '/images/token-tool/tokentool-side.png',
    },
    {
      id: 'token-3',
      title: 'Batch Collect Token',
      description: 'With the Batch Collect Token feature, you can consolidate tokens from multiple addresses into a single wallet effortlessly. Whether you\'re redistributing tokens or consolidating funds for a specific purpose, TokenTool simplifies the process. Just provide the source addresses and the destination wallet, and TokenTool will handle the rest, ensuring a smooth and secure token consolidation experience.',
      icon: '/images/token-tool/collect.svg',
      image: '/images/token-tool/collect.png',
      animationImage: '/images/token-tool/tokentool-side.png',
    },
    {
      id: 'token-4',
      title: 'Batch Token Swap',
      description: 'With this powerful tool, you can execute token swaps in bulk, saving you time and effort. Whether you\'re migrating tokens between different blockchain networks or exchanging one token for another, TokenTool streamlines the process. Simply specify the source and target tokens, along with the desired swap ratio, and TokenTool will facilitate the seamless execution of your batch token swaps.',
      icon: '/images/token-tool/swap.svg',
      image: '/images/token-tool/swap.png',
      animationImage: '/images/token-tool/tokentool-side.png',
    },
    {
      id: 'token-5',
      title: 'Batch Balance Check',
      description: 'Batch Balance Check feature can retrieve the token balances of multiple wallets, providing you with a comprehensive overview of your holdings. Whether you\'re performing an audit, monitoring token distribution, or assessing your portfolio, TokenTool empowers you with accurate and timely balance information.',
      icon: '/images/token-tool/balance.svg',
      image: '/images/token-tool/balance.png',
      animationImage: '/images/token-tool/tokentool-side.png',
    },
  ];
  return (
    <>
      <NextSeo
        title={metaTitle}
        description={metaDesc}
        openGraph={{
          title: `${metaTitle}`,
          description: `${metaDesc}`,
          images: [
            {
              url: `${metaImg}`,
            }
          ]
        }}
      />
      <Hero_12/>
      <Benifits
        title={'Features of Alchemis Token Tool'}
        subTitle={'Whether you\'re a blockchain enthusiast, a crypto trader, or a project manager, TokenTool is designed to simplify your token management journey.'}
        benefitsData={benefitsData}
      />
      <SingleBenefits singleBenifits={singleBenifits} />
      {/* <Testimonial/> */}
      <CallToActions
        title={'Try out our cool Alchemis Token Tool!'}
        background={'/images/cta-token.png'}
        description={'Discover how specific cryptocurrencies work — and get a bit of each crypto to try out for yourself.\n'}
        btnText={'Start Now'}
        link={'https://tokentool.alchemis.com/multi-sender'}
      />
    </>
  );
};

export default TokenTool;
